import { render, staticRenderFns } from "./PdfPrinter.vue?vue&type=template&id=533607c5&scoped=true&"
import script from "./PdfPrinter.vue?vue&type=script&lang=ts&"
export * from "./PdfPrinter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533607c5",
  null
  
)

export default component.exports